import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as actionTypes from './constants';
import {
  addCampaignFailure,
  addCampaignSuccess,
  deleteCampaignFailure,
  deleteCampaignSuccess,
  fetchCampaignsFailure,
  fetchCampaignsSuccess,
  fetchWizardDataFailure,
  fetchWizardDataSuccess,
  updateCampaignFailure,
  updateCampaignSuccess,
} from './campaigns-actions';

export function* doFetchWizardData(action) {
  const { id } = action.payload;
  try {
    const results = yield call(callApi, {
      endpoint: `campaigns/wizard${id ? `?id=${id}` : ''}`,
      options: {
        errorMessage: 'Could not fetch wizard data',
        retryAction: action,
      },
    });
    yield put(fetchWizardDataSuccess(results));
  } catch (err) {
    yield put(fetchWizardDataFailure(err));
  }
}

export function* doFetchCampaigns(action) {
  try {
    const results = yield call(callApi, {
      endpoint: 'campaigns',
      options: {
        errorMessage: 'Could not fetch campaigns',
        retryAction: action,
      },
    });
    yield put(fetchCampaignsSuccess(results));
  } catch (err) {
    yield put(fetchCampaignsFailure(err));
  }
}

export function* doUpdateCampaign(action) {
  const { id } = action.payload;
  try {
    const results = yield call(callApi, {
      endpoint: `campaigns/${id}`,
      options: {
        method: 'PUT',
        body: JSON.stringify(action.payload),
        errorMessage: 'Could not update campaign data',
        retryAction: action,
      },
    });
    yield put(updateCampaignSuccess(results));
  } catch (err) {
    yield put(updateCampaignFailure(err));
  }
}

export function* doAddCampaign(action) {
  try {
    const results = yield call(callApi, {
      endpoint: 'campaigns',
      options: {
        method: 'POST',
        body: JSON.stringify(action.payload),
        errorMessage: 'Could not add campaign data',
        retryAction: action,
      },
    });
    yield put(addCampaignSuccess(results));
  } catch (err) {
    yield put(addCampaignFailure(err));
  }
}

export function* doDeleteCampaign(action) {
  const { id } = action.payload;
  try {
    const results = yield call(callApi, {
      endpoint: `campaigns/${id}`,
      options: {
        method: 'DELETE',
        errorMessage: 'Could not delete campaign',
        retryAction: action,
      },
    });
    yield put(deleteCampaignSuccess(results));
  } catch (err) {
    yield put(deleteCampaignFailure(err));
  }
}

function* watchFetchAnnouncements() {
  yield takeLatest(actionTypes.FETCH_CAMPAIGNS_REQUEST, doFetchCampaigns);
}

function* watchUpdateAnnouncement() {
  yield takeLatest(actionTypes.UPDATE_CAMPAIGN_REQUEST, doUpdateCampaign);
}

function* watchFetchWizardData() {
  yield takeLatest(actionTypes.FETCH_CAMPAIGN_WIZARD_DATA_REQUEST, doFetchWizardData);
}

function* watchAddAnnouncement() {
  yield takeLatest(actionTypes.ADD_CAMPAIGN_REQUEST, doAddCampaign);
}

function* watchDeleteAnnouncement() {
  yield takeLatest(actionTypes.DELETE_CAMPAIGN_REQUEST, doDeleteCampaign);
}

export default [
  fork(watchFetchAnnouncements),
  fork(watchUpdateAnnouncement),
  fork(watchFetchWizardData),
  fork(watchAddAnnouncement),
  fork(watchDeleteAnnouncement),
];
